module.exports = __webpack_public_path__ + "img/building.b864d7ff.svg";